import { FC } from 'react';

export const Navbar: FC = () => <></>;
